import { Component, Input} from '@angular/core';
import { TicketResponse } from 'src/app/flight/models/Ticket';

import { StatusTicketCard } from 'src/app/flight/models/StatusTicketCard';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { PasseLivreService } from 'src/app/core/services/passe-livre/passe-livre.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { DialogInfoComponent } from 'src/app/shared/components/dialog-info/dialog-info.component';
import { MyFlightsComponent } from '../my-flights/my-flights.component';
import { CREW_INFO, getItemFromSessionStorage } from 'src/app/utils/SessionStorageUtil';
import { CrewInfo } from 'src/app/models/CrewInfo';
import { CancelTicketRequest } from '../models/CancelTicketRequest';
import { DefaultResponse } from 'src/app/models/DefaultResponse';


@Component({
    selector: 'app-card-ticket-triple',
    templateUrl: './card-ticket-triple.component.html',
    styleUrls: ['./card-ticket-triple.component.scss'],
    standalone: false
})
export class CardTicketTripleComponent {
  public StatusTicketCard = StatusTicketCard;

  @Input() ticket1?: TicketResponse;
  @Input() ticket2?: TicketResponse;
  @Input() ticket3?: TicketResponse;
  @Input() status: StatusTicketCard;

  @Input() ActiveTicketList: TicketResponse;
  // @Input() inactiveTicketList: TicketResponse;
  // @Input() cancelledTicketList: TicketResponse;

  
  
  public isActive: boolean;

  constructor(private dialog: MatDialog, 
              private passeLivreService: PasseLivreService,
              private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.isActive = this.status === StatusTicketCard.ACTIVE;
  }

  cancelTicket(): void {
    const html: string = 'Para confirmar seu cancelamento, clique em "Confirmar".<br>ATENÇÃO: Ao cancelar uma reserva, todos os voos associados à mesma serão cancelados.';
    const dialogConfirmRef = this.dialog.open(DialogConfirmComponent, {
      data: { title: 'Cancelar Voo', html }
    });

    dialogConfirmRef.afterClosed().subscribe((confirm: boolean) => {
      if (confirm) {
        this.confirmCancel();
      }
    });
  }

  private confirmCancel(): void {
    if (!this.ticket1 || !this.ticket2 || !this.ticket3) return;

    const crewInfo = getItemFromSessionStorage<CrewInfo>(CREW_INFO);

    if (crewInfo) {
      this.cancelSingleTicket(this.ticket1, crewInfo, 'Ticket 1 cancelado com sucesso!');
      this.cancelSingleTicket(this.ticket2, crewInfo, 'Ticket conexão 1 cancelado com sucesso!');
      this.cancelSingleTicket(this.ticket3, crewInfo, 'Ticket conexão 2 cancelado com sucesso!');
    } else {
      this.notificationService.error('Não foi possível cancelar o ticket, o sistema não conseguiu recuperar o nome do tripulante.');
    }
  }

  private cancelSingleTicket(ticket: TicketResponse, crewInfo: CrewInfo, successMessage: string): void {
    const request: CancelTicketRequest = { 
      pnrCode: ticket.pnrCode, 
      givenName: crewInfo.fullName,
      flightDate: ticket.departureDateLt
    };

    this.passeLivreService.cancelTicket(request).subscribe({
      next: (response: DefaultResponse) => {
        if (response.status === 0) {
          this.notificationService.success(successMessage);
          MyFlightsComponent.instance.refreshTickets();
        } else {
          this.showErrorDialog(response.message);
        }
      },
      error: () => {
        this.notificationService.error('Houve um erro ao cancelar o ticket!');
      }
    });
  }

  private showErrorDialog(error: string): void {
    const html: string = `<span class="error-message">${error}</span>`;

    this.dialog.open(DialogInfoComponent, {
      width: '600px',
      data: { title: 'Ocorreu um erro!', html }
    });
  }

  copyText(text: string): void {
    if (!text) return;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
